// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"747":"df152cdb","807":"df152cdb","886":"d9cbe423"}[chunkId] + ".chunk.css";
};